import { useEffect, useState } from 'react'
import { t, Trans } from '@lingui/macro'

import { Badge, Dialog, DialogContent, DialogTitle, Divider, IconButton, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder'

import { DmpConnect, EfficienceWebIframe } from '@/features/dmp-connect'
import { useAppSelector } from '@/redux/rootReducer'
import { selectDMPConnectTlsiConnectorId } from '@/redux/reducers/dmp-connect.reducer'

import { HeaderIconButton } from './HeaderIconButton'

export function DMPConnectIndicator() {
  const [openDialog, setOpenDialog] = useState(false)

  const tlsiConnectorId = useAppSelector(selectDMPConnectTlsiConnectorId)

  return (
    <>
      <Tooltip title={t`DMP Connect`}>
        <HeaderIconButton onClick={() => setOpenDialog(true)}>
          <Badge
            color={tlsiConnectorId ? 'success' : 'error'}
            overlap="circular"
            variant="dot"
            sx={{
              position: 'unset',
            }}
          >
            <CreateNewFolderIcon />
          </Badge>
        </HeaderIconButton>
      </Tooltip>
      <DmpConnectDialog open={openDialog} onClose={() => setOpenDialog(false)} />
    </>
  )
}

function DmpConnectDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [showEfficienceWeb, setShowEfficienceWeb] = useState(false)

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setShowEfficienceWeb(false)
      }, 100)
    }
  }, [open])

  return (
    <Dialog fullWidth maxWidth={showEfficienceWeb ? 'xl' : 'sm'} open={open} onClose={onClose} PaperProps={{ sx: { height: 'calc(100vh - 24px)' } }}>
      <DialogTitle>
        <Trans>DMP Connect</Trans>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {showEfficienceWeb && <Divider />}
      {showEfficienceWeb ? (
        <EfficienceWebIframe />
      ) : (
        <DialogContent>
          <DmpConnect onOpenDMPAndMSS={() => setShowEfficienceWeb(true)} />
        </DialogContent>
      )}
    </Dialog>
  )
}
